import { useCurrency } from '../../context/CurrencyContext';

interface FormattedAmountProps {
  amount: number;
  /** Override display currency (e.g. stored payment currency). Uses portal preference when omitted. */
  currencyCode?: string;
  className?: string;
}

export function FormattedAmount({ amount, currencyCode, className }: FormattedAmountProps) {
  const { formatAmount } = useCurrency();
  return <span className={className}>{formatAmount(amount, currencyCode)}</span>;
}

export function CurrencyInputPrefix({ className }: { className?: string }) {
  const { symbol } = useCurrency();
  return <span className={className}>{symbol}</span>;
}
